import { useEffect, useState } from 'react';

export function useNicepayScript(src: string) {
    const [ready, setReady] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (!src) return;

        // 이미 로드된 스크립트가 있는지 확인
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) {
            setReady(true);
            return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        script.onload = () => setReady(true);
        script.onerror = () => setError(new Error('Failed to load NICEPAY script'));

        document.head.appendChild(script);

        return () => {
            // 스크립트는 캐시를 위해 제거하지 않음
        };
    }, [src]);

    return { ready, error };
}
